((document, window, history) => {
	let pushState = history.pushState;


		// Tolerance (px) is the size a viewport can chance
	// before updating css variables this prevents jerky
	// resizing when browser chrome disappears on mobile
	const tolerance = 60;

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${ vh }px`);
	let lastHeight = window.innerHeight;

	let vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', `${ vw }px`);
	let lastWidth = window.innerWidth;

	let header;

	if (document.querySelector('.site-header')) {
		header = document.querySelector('.site-header').getBoundingClientRect().height;
		document.documentElement.style.setProperty('--navbar-offset', header);
		if (document.querySelector('.pre-header')) {
			header += document.querySelector('.pre-header').getBoundingClientRect().height;
		}
		document.documentElement.style.setProperty('--nav-offset', header);
	}

	const resizeVars = () => {
		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${ vh }px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth != window.innerWidth) {
			vw = window.innerWidth * 0.01;
			document.documentElement.style.setProperty('--vw', `${ vw }px`);
			lastWidth = window.innerWidth;
		}

		if (document.querySelector('.site-header')) {
			header = document.querySelector('.site-header').getBoundingClientRect().height;
			document.documentElement.style.setProperty('--navbar-offset', header);
			if (document.querySelector('.pre-header')) {
				header += document.querySelector('.pre-header').getBoundingClientRect().height;
			}
			document.documentElement.style.setProperty('--nav-offset', header);
		}
	};
	window.addEventListener('resize', () => {
		resizeVars();
	});
	setTimeout(function() {
		resizeVars();
	}, 100);


    // default cookie compliance script
    function cookieCompliance() {
		if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
			document.querySelector('.farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');
			});
		}
	}

    // default navicon
    function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active');document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active')
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

    history.pushState = function (state) {
        if (typeof history.onpushstate == "function") {
            history.onpushstate({ state: state });
        }
        return pushState.apply(history, arguments);
    };

    document.addEventListener("DOMContentLoaded", () => {
		document.documentElement.classList.add(_farlo.browser.init());

		//window._farloUi.init();

        if (document.querySelector('.site-navigation__navicon')) {
            navicon();
        }

        if (document.querySelector('.farlo-ui-biscuit-banner')) {
            cookieCompliance();
        }
    });




	const youTubeRegex = RegExp(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);


	function farloUiLightbox(elem, div) {
		if (elem.querySelector('.wp-block-image')) {
			elem.querySelector('.wp-block-image').addEventListener('click', function(e) {
				const clonedEmbed = e.currentTarget.closest('.wp-block-group').querySelector('.wp-block-embed').cloneNode(true);
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').appendChild(clonedEmbed);
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (elem.nextElementSibling && elem.nextElementSibling.value) {
			elem.addEventListener('click', function(e) {
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').classList.add('dynamic');
				if (e.target.nextElementSibling && e.target.nextElementSibling.value) {
					div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = e.target.nextElementSibling.value;
				}
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (elem.dataset.video) {
			elem.addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + elem.dataset.video.match(youTubeRegex)[ 1 ] + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (elem.querySelector('a[href*="youtu.be"]')) {
			elem.querySelector('a[href*="youtu.be"]').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + e.currentTarget.href.match(youTubeRegex)[ 1 ] + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (div.querySelector('.farlo-ui-lightbox__button-close')) {
			div.querySelector('.farlo-ui-lightbox__button-close').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');
				e.currentTarget.closest('.farlo-ui-lightbox').classList.remove('farlo-ui-lightbox--active');
				if (div.querySelector('.farlo-ui-lightbox__inner-content.dynamic')) {
					div.querySelector('.farlo-ui-lightbox__inner-content').classList.remove('dynamic');
				}
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '';

				if (elem.classList.contains('site-geo-targeting')) {
					window._farlo.storage.set('geotargeted', 'true', 'cookie');
				}
			});
		}
	}


	const lightboxEmbed = document.querySelectorAll('.farlo-ui-lightbox__toggle, [data-video]');
	let div;
	let divInner;
	let divInnerContent;
	let divClose;

	if (lightboxEmbed.length > 0) {
		div = document.createElement('div');
		divInner = document.createElement('div');
		divInnerContent = document.createElement('div');
		divClose = document.createElement('button');
		div.className = 'farlo-ui-lightbox';
		divInner.className = 'farlo-ui-lightbox__inner';
		divInnerContent.className = 'farlo-ui-lightbox__inner-content';
		divClose.className = 'farlo-ui-lightbox__button-close';

		document.body.appendChild(div);
		document.querySelector('.farlo-ui-lightbox').appendChild(divInner);
		document.querySelector('.farlo-ui-lightbox__inner').appendChild(divInnerContent);
		document.querySelector('.farlo-ui-lightbox__inner').appendChild(divClose);

		lightboxEmbed.forEach(function(elem) {
			farloUiLightbox(elem, div);
		});
	}


	function pageScroll(target,offset) {
		var elem = document.querySelector(target);
		if (elem) {
			var scroll = (window.pageYOffset + elem.getBoundingClientRect().top) - window.getComputedStyle(document.documentElement).getPropertyValue('--nav-offset');
			if (typeof offset != "undefined") {
				scroll = scroll-offset;
			}
			window.scroll({
				top : scroll,
				behavior : 'smooth'
			})

		}
	}

	// document.querySelectorAll("a").forEach(elem => {
	// 	if (elem.href) {
	// 		if (_farlo.helpers.urls.isHash(elem)) {
	// 			elem.addEventListener("click", (e) => {
	// 				e.preventDefault();
	// 				let url = elem.href.split("#");
	// 				let selector = "#" + url[1];
	// 				if (document.querySelector(selector)) {
	// 					pageScroll(selector);
	// 				} else {
	// 					document.location.href = elem.href;
	// 				}
	// 			});
	// 		}
	// 	}
	// });
	if (document.location.hash) {
		let url = document.location.href.split("#");
		let selector = "#" + url[1];
		try {
			if (document.querySelector(selector)) {
				pageScroll(selector);
			}
		} catch(ex) {

		}
	}

	window.addEventListener("load", () => {
		setTimeout(() => {
			document.querySelector("body").classList.add("loaded");
		},100);
	})


	if (document.querySelector('.site-farlo-ui-crm')) {
		document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
			farloUiMcSignup(_sel);
		});

		document.querySelectorAll('.site-farlo-ui-crm__toggle').forEach((_sel) => {
			_sel.addEventListener('click', (e) => {
				e.preventDefault();
				farloUiMcSignup(document.querySelector('#' + e.currentTarget.dataset.crmButtonFor));
			});
		});
	}
	function farloUiMcSignup(_sel) {
		let farloUiSignupForm = null;

		if (farloUiSignupForm) {
			farloUiSignupForm.toggleForm();
		} else {
			farloUiSignupForm = new FarloUiMc(_sel.id);
		}
	}


})(document, window, history);